"use client";
import styled from "@emotion/styled";
import React from "react";
import { CommonCard, Layout } from "./molecules";

const OurVision = ({ data }) => {
  return (
    <Layout>
      <CommonCard className="">
        <Academy1 className="ourVision">
          <p>{data?.description}</p>
          <h3 className="text-3xl lg:text-[42px] leading-normal font-extrabold relative">{data?.title}</h3>
        </Academy1>
      </CommonCard>
    </Layout>
  );
};

export default OurVision;

const Academy1 = styled.div`
  color: #fff;
  padding: 40px;
  height: 468px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
`;
const P = styled.p``;
